(function () {
    'use strict';

    angular
        .module('app')
        .factory('ftsOptionsService', ftsOptionsService);

    ftsOptionsService.$inject = ['$http', '$q', '$localStorage'];

    function ftsOptionsService($http, $q, $localStorage) {
        var localStorage = $localStorage;

        var service = {
            getFtsIndexLocation: getFtsIndexLocation,
            validateFtsIndexLocation: validateFtsIndexLocation,
            setFtsIndexLocation: setFtsIndexLocation,
            processing: false
        };

        return service;

        function getFtsIndexLocation() {
            service.processing = true;
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/AdminOptions/FTSGetIndexLocation/').then(function (response) {
                //service.ftsIndexLocation = response.data;
                service.processing = false;
                deferred.resolve(response.data);
            }, function (response) {
                service.processing = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }


        function validateFtsIndexLocation(ftsIndexLocationId) {
            service.processing = true;
            var deferred = $q.defer();
            var request = $http({
                url: '../Synergis.WebApi/api/AdminOptions/FTSValidateLocation',
                method: 'POST',
                data: JSON.stringify(ftsIndexLocationId),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            request.then(function (response) {
                service.processing = false;
                deferred.resolve(response.data);
            }, function (response) {
                service.processing = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function setFtsIndexLocation(ftsIndexLocationId, bOverwrite) {
            service.processing = true;
            var deferred = $q.defer();
            var request = $http({
                url: '../Synergis.WebApi/api/AdminOptions/FTSSetIndexLocation/' + bOverwrite,
                method: 'POST',
                data: JSON.stringify(ftsIndexLocationId),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            request.then(function (response) {
                service.processing = false;
                deferred.resolve(response.data);
            }, function (response) {
                service.processing = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }
    }


})();